import axios, { config } from '..';
import { UPDATE_ARTIST_SUCCESS, UPDATE_ARTIST_FAILED } from '../../actionTypes';

export default (body, id) => async (dispatch) => {
  try {
    let response;
    if (body) {
      response = await axios.patch(
        `/providers/artists/${id}/update`,
        body,
        config
      );
    }

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: UPDATE_ARTIST_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: UPDATE_ARTIST_FAILED, error });
  }
};
